export default {
  dp: {
    footer: {
      copyright: 'DocuPet Inc. Tous droits réservés.',
      tos: 'Conditions de service',
      privacy: 'Politique de confidentialité',
      cookieSettings: 'Paramètres des témoins',
    },
    navbar: {
      toggle: {
        close: 'Fermer',
        default: 'Menu',
      },
      tagStore: 'Magasin de balises',
      shop: 'Magasin',
      tagGallery: 'Galerie de tags',
      safeAndHappyFund: 'Safe&Happy Fund',
      licensing: 'Licence',
      homeSafe: 'Home<em>Safe</em><sup>&reg;</sup>',
      store: 'Magasin',
      about: 'À propos',
      licensingInfo: 'À propos des nouvelles licences',
      faq: 'FAQ',
      aboutRenewing: 'À propos du renouvellement des licences',
      signup: 'Inscrivez-vous',
      login: 'Connexion',
      dashboard: 'Mon tableau de bord',
      myDetails: 'Mes Details',
      myAccount: 'Mon Compte',
      logOut: 'Se déconnecter',
      yourAccount: 'Compte',
      myPets: 'Mes animaux de compagnie',
      profileSettings: 'Paramètres de profil',
      billingDetails: 'Paiements et abonnements',
      orderHistory: 'Historique des commandes',
      helpDesk: "Centre D'aide",
      logoDescription: 'DocuPet - Un foyer sûr et heureux pour chaque animal',
      skipToMainContent: 'Passer au contenu principal',
      basket: {
        ariaLabel: "Panier d'achats ({basketCount} articles)",
      },
      petGuardians: "Gardiens d'animaux de compagnie",
      shopDropdown: {
        shopAll: 'Magasiner Tout',
        tags: 'Médailles',
        smartTracker: 'Smart Tracker',
        walletCards: 'Cartes de portefeuille',
        collars: 'Colliers',
      },
      language: 'Langage',
      locales: {
        en_CA: 'English [CA]',
        en_US: 'English [US]',
        es_US: 'Español [US]',
        fr_CA: 'Français [CA]',
      },
    },
    addAddress: {
      manualAddressHeader: "Ajoutez l'adresse",
    },
    errorMessages: {
      poBoxOnly:
        "Nous avons besoin d'une adresse physique pour votre profil au cas où votre animal se perdrait et devrait vous être rendu. Vous pouvez ajouter une adresse postale supplémentaire en décochant la case ci-dessous.",
      invalidCharacters: 'Le {field} contient des caractères non valides',
    },
    input: {
      firstName: {
        label: 'Prénom',
        placeholder: 'Entrez votre prénom',
        customErrorMessage: { isEmpty: 'Your first name is required' },
      },
      lastName: {
        label: 'Nom de famille',
        placeholder: 'Entrer le nom de famille',
        customErrorMessage: { isEmpty: 'Your last name is required' },
      },
      email: {
        label: 'Adresse courriel',
        placeholder: 'Entrer adresse courriel',
        customErrorMessage: {
          isEmpty: 'Please enter your email address',
          hasValue: 'Please enter a valid email address',
        },
        asyncErrorMessage: {
          emailAlreadyExists: `<strong>This email address already exists in our system.</strong><br/>If this is your account, please click <a class="text-decoration-underline" href="{loginLink}">here</a> to log in. Otherwise, please double check you're entering the correct email address.`,
          accountAlreadyExists: `<strong>This email address already exists in our system.</strong><br/>If you have previously registered a pet, we likely have your record on file. Visit the <a class="text-decoration-underline" href="{loginLink}">Fetch my record</a> page to continue.`,
        },
      },
      password: {
        label: 'Créer un mot de passe',
        placeholder: 'Créer un mot de passe',
        customErrorMessage: {
          isEmpty: 'Please enter a password',
          hasValue: 'Your password does not meet the requirements listed below',
        },
        show: 'Masquer le mot de passe',
        hide: 'Montrer le mot de passe',
      },
      agreeToTermsConditions: {
        label: "Je suis d'accord",
        customErrorMessage: 'Please read and agree to the Terms of Service to proceed',
      },
      addressSearch: {
        label: '',
        placeholder: 'Start typing to search for {selectedType}',
        placeholderAddress: 'address',
        customErrorMessage: 'Please provide your address',
      },
      unit: {
        label: 'Unité / APT / SUITE',
        placeholder: '',
        customErrorMessage:
          'The unit / apt / suite field may only contain alpha-numeric characters, spaces and periods (e.g. Ste. 4, Apt. B).',
      },
      civic: {
        label: 'Nombre',
        placeholder: '',
        customErrorMessage: 'Please enter your address number',
      },
      street: {
        label: 'Rue',
        placeholder: 'Entrez le nom de la rue',
        customErrorMessage: 'Please enter your street name',
      },
      additional: {
        label: '',
        placeholder: 'Supplémentaire / Boîte postale',
      },
      city: {
        label: 'Ville',
        placeholder: 'Entrez le nom de la ville',
        customErrorMessage: 'Please enter your city name',
      },
      state: {
        label: 'State',
        placeholder: '',
        customErrorMessage: 'Please select your state',
      },
      province: {
        label: 'Province',
        placeholder: '',
        customErrorMessage: 'Please select your province',
      },
      postalCode: {
        label: 'Code postal',
        placeholder: 'Entrez le code postal',
        customErrorMessage: 'Please enter your postal code',
      },
      zipCode: {
        label: 'Zip Code',
        placeholder: 'Enter zip code',
        customErrorMessage: 'Please enter your ZIP code',
      },
    },
    ageOptions: {
      underSixMonths: 'Under 6 months',
      sixMonthsToOneYear: '6 months - 1 year',
      oneYear: '1 year',
      timesYears: '{yearNumber} years',
      seventeenPlusYears: '17+ years',
    },
    colors: {
      white: 'Blanc',
      lightGrey: 'Gris clair',
      darkGrey: 'Gris foncé',
      black: 'Noir',
      orange: 'Orange',
      red: 'Rouge',
      cream: 'Crème',
      apricot: 'Abricot',
      golden: 'Or',
      tan: 'Tan',
      brown: 'Brun',
      darkBrown: 'Marron foncé',
      lightSilver: 'Argent clair',
      silver: 'Argent',
      lilac: 'Lilas',
      blue: 'Bleu',
      darkBlue: 'Bleu foncé',
      yellow: 'Jaune',
      rust: 'Rouille',
      lightBrown: 'Marron clair',
      grey: 'Gris',
    },
    generic: {
      optional: 'Optionnel',
    },
    stripeForm: {
      cvcHeader: 'Guide de localisation du code CVV/CVC',
      cvcHelper:
        'Le code CVV/CVC (Card Verification Value/Code) se trouve au dos de votre carte de crédit/débit, à droite de la bande de signature blanche. Ce sont toujours les 3 derniers chiffres en cas de VISA et MasterCard. Veuillez copier votre code CVV/CVC au dos de votre carte et poursuivre votre paiement.',
      cvcHelperImageAlt: "Recherchez le code de sécurité à 3 chiffres au dos de votre carte et le code de sécurité à 4 chiffres à l'avant.",
      cardNumber: 'Numéro de carte',
      expiryDate: "Date d'expiration",
      cvcNumber: 'CVC',
      country: 'Country',
      postalCode: 'Code postal',
      postalCodePlaceholder: 'A1A 0A0',
    },
    suggestedJurisdictions: {
      title: 'Dites-nous dans quelle communauté vous vivez',
      fallbackJurisdictionOptionLabel: 'Aucune des réponses ci-dessus',
    },
    securePasswordCheckList: {
      isSecure: 'Votre mot de passe est sécurisé!',
      oneLowerChar: 'Un caractère minuscule (ex. "j", "p", "a")',
      oneUpperChar: 'Un caractère majuscule (ex. "J", "P", "A")',
      oneDigitChar: 'Un chiffre (ex. "1", "5", "8")',
      oneSpecialChar: 'Un caractère spécial (ex. "&", "#", "$")',
      min: '12 caractères minimum',
    },
    error: {
      title: 'Esprits!',
      body: "On dirait que quelque chose s'est mal passé ! Si vous continuez à recevoir ce message, veuillez nous le faire savoir.",
    },
  },
};
